// @ts-nocheck
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { GLOBAL_CONSTANT } from '../../../../../contants/global.const';
import { SEND_SERVICE } from '../../../../../services/send.service';

@Injectable({
  providedIn: 'root',
})
export class FileUploadService {
  readonly sendService = inject(SEND_SERVICE);
  readonly Global = inject(GLOBAL_CONSTANT);

  public saveUpload(body, params): Observable<any> {
    const url = this.Global.services.files.info();
    return this.sendService.post(url, body, { params });
  }

  public updateFile(body, params): Observable<any> {
    const url = this.Global.services.files.info();
    return this.sendService.put(url, body, { params });
  }

  public listFiles(params, entityUrl?: string): Observable<any> {
    const url = entityUrl ?? this.Global.services.files.draft();

    return this.sendService.get(url, { params });
  }

  public listFilesType(params): Observable<any> {
    const url = this.Global.services.files.getDropData();
    return this.sendService.get(url, { params });
  }

  public assignUri(params): Observable<any> {
    const url = this.Global.services.files.psurl();
    return this.sendService.get(url, { params });
  }

  public deleteFile(params): Observable<any> {
    const url = this.Global.services.files.info();
    return this.sendService.delete(url, { params });
  }

  public deleteFileDraftById(body, params): Observable<any> {
    const url = this.Global.services.files.deleteFileDraftById();
    return this.sendService.put(url, body, { params });
  }

  public setUpload(url, formData, fields): Observable<any> {
    return this.sendService.postHttpEvents(url, formData, fields, true);
  }

  public getTask(ids) {
    const params = { ids: JSON.stringify([ids]) };
    return new Promise((resolve, reject) => {
      this.getTaskServ(params).subscribe(
        (resp: any) => resolve(resp),
        (resp: any) => reject(resp)
      );
    });
  }

  public getTaskServ<T>(params): Observable<T> {
    const url = this.Global.services.task.getOne();
    return this.sendService.get(url, { params });
  }

  public copyFile(body, params): Observable<any> {
    const url = this.Global.services.files.copyFile();
    return this.sendService.post(url, body, { params });
  }

  public getRemainingFileCount(params): Observable<any> {
    const url = this.Global.services.files.getRemainingFileCount();
    return this.sendService.get(url, { params });
  }
}
